<template>
    <div class="connectionContainer">
        <div class="connectionHeader">
            <div class="modal_title"> モールイベント</div>
        </div>
        <div class="connectionContents">
            <div class="modal_body">
                <div class="modal_form">
                    <div class="modal_input">
                        <label>店舗</label>
                        <select v-model="event.service_id">
                            <option value="" disabled>店舗</option>
                            <option v-for="service in filteredService()" :value="service.id" v-bind:key="service.id">{{
                                service.name
                            }}</option>
                        </select>
                    </div>
                    <div class="modal_input">
                        <label>開催期間</label>
                        <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                            input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="開始日"
                            v-model="datePickerStartDate"
                            :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                        <select class="timeSel" v-model="startTimeHour">
                            <option v-for="hour in hours()" :value="hour" v-bind:key="hour">{{ hour }}</option>
                        </select>
                        ：
                        <select class="timeSel" v-model="startTimeMinute">
                            <option v-for="minute in minutes()" :value="minute" v-bind:key="minute">{{ minute }}
                            </option>
                        </select>
                        ～
                        <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                            input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="終了日"
                            v-model="datePickerEndDate"
                            :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                        <select class="timeSel" v-model="endTimeHour">
                            <option v-for="hour in hours()" :value="hour" v-bind:key="hour">{{ hour }}</option>
                        </select>
                        ：
                        <select class="timeSel" v-model="endTimeMinute">
                            <option v-for="minute in minutes()" :value="minute" v-bind:key="minute">{{ minute }}
                            </option>
                        </select>
                    </div>
                    <div class="modal_input">
                        <label>イベント名</label>
                        <input type="text" placeholder="イベント名" v-model="eventName">
                    </div>
                </div>
                <div class="modal_submit">
                    <template v-if="createMode">
                        <Button width="100px" @click="createEvent">追加</Button>
                    </template>
                    <template v-else>
                        <Button width="100px" @click="updateEvent">更新</Button>
                    </template>
                </div>
            </div>
        </div>
        <div class="connectionFooter">
            <template v-if="!createMode">
                <Button class="btn deleteBtn" @click="openDeleteModal">削除</Button>
            </template>
        </div>
        <modal name="deleteModal" :draggable="false" :resizable="false" width="60%" height="200px">
            <DeleteModal @canceled="closeDeleteModal" @deleted="deleteEvent" />
        </modal>
    </div>
</template>

<script>
import DeleteModal from './DeleteModal.vue';
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
    props: {
        createMode: Boolean,
        eventId: Number,
    },
    components: {
        DeleteModal,
        Datepicker,
    },
    data() {
        return {
            event: {},
            services: {},
            ja: ja,
            datePickerStartDate: null,
            startTimeHour: null,
            startTimeMinute: null,
            datePickerEndDate: null,
            endTimeHour: null,
            endTimeMinute: null,
            eventName: null,
        }
    },
    mounted: function () {
        //サービス名プルダウンセット
        this.getServiceId();
        if (this.eventId) {
            this.fetchMallEvent(this.eventId);
        }

    },
    methods: {
        //サービスIDの一覧取得
        getServiceId: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/service/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //追加
        createEvent: function () {
            this.$store.dispatch("loading", true);
            const data = {
                service_id: this.event.service_id,
                start_day: this.$dayjs(this.datePickerStartDate).format("YYYY-MM-DD"),
                start_time_hour: this.startTimeHour,
                start_time_minute: this.startTimeMinute,
                end_day: this.$dayjs(this.datePickerEndDate).format("YYYY-MM-DD"),
                end_time_hour: this.endTimeHour,
                end_time_minute: this.endTimeMinute,
                event_name: this.eventName,
            };
            this.axios.post("/api/mallAdCosts/MallEvents", data)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                    this.$store.dispatch("loading", false);
                }).finally(() => {
                });
        },
        //変更
        updateEvent: function () {
            this.$store.dispatch("loading", true);
            const data = {
                service_id: this.event.service_id,
                start_day: this.$dayjs(this.datePickerStartDate).format("YYYY-MM-DD"),
                start_time_hour: this.startTimeHour,
                start_time_minute: this.startTimeMinute,
                end_day: this.$dayjs(this.datePickerEndDate).format("YYYY-MM-DD"),
                end_time_hour: this.endTimeHour,
                end_time_minute: this.endTimeMinute,
                event_name: this.eventName,
            };
            this.axios.put("/api/mallAdCosts/MallEvents/" + this.eventId, data)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                    this.$store.dispatch("loading", false);
                }).finally(() => {
                });
        },
        //削除
        deleteEvent: function () {
            this.$store.dispatch("loading", true);
            this.axios.delete("/api/mallAdCosts/MallEvents/" + this.eventId)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                    this.$store.dispatch("loading", false);
                }).finally(() => {
                });
        },
        //変更・削除時に画面に設定内容を表示
        fetchMallEvent: function (event_id) {
            var url = "/api/mallAdCosts/MallEvents/" + event_id;
            var data = {
            }
            this.axios.get(url, { params: data })
                .then((res) => {
                    this.event = { ...res.data };
                    this.datePickerStartDate = this.event.start_day;
                    this.startTimeHour = this.event.start_time_hour;
                    this.startTimeMinute = this.event.start_time_minute;
                    this.datePickerEndDate = this.event.end_day;
                    this.endTimeHour = this.event.end_time_hour;
                    this.endTimeMinute = this.event.end_time_minute;
                    this.eventName = this.event.event_name;
                }).catch(() => {
                }).finally(() => {
                });
        },
        //削除モーダル オープン・クローズ
        openDeleteModal() {
            this.$modal.show('deleteModal');
        },
        closeDeleteModal() {
            this.$modal.hide('deleteModal');
        },
        modalClosed(modalName) {
            this.modalShow = false;
            this.$modal.hide(modalName);
        },
        modalClose() {
            this.$emit('modalClosed');
        },
        filteredService() {
            let result = [];
            // モールのみ
            let list = [4, 10, 26, 28, 55];
            for (var idx in this.services) {
                let service = this.services[idx];
                if (list.includes(service.id)) {
                    result.push(service);
                }
            }
            result.push({ id: 100, name: '楽天全店' });
            return result;
        },
        hours() {
            let hours = [];
            for (let i = 0; i < 24; i++) {
                let hourString = i.toString().padStart(2, '0');
                hours.push(hourString);
            }
            return hours;
        },
        minutes() {
            let minutes = [];
            for (let i = 0; i < 60; i += 59) {
                let minutesString = i.toString().padStart(2, '0');
                minutes.push(minutesString);
            }
            return minutes;
        }
    }
}
</script>


<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .modal_form
            padding: 32px
            h3
                font-size: 1.6rem
                font-weight: 700
                margin-bottom: 24px
            p
                font-size: 1.4rem
                color: #777
            .modal_input
                margin-bottom: 24px
                display: flex
                justify-content: start
                align-items: center
                label
                    font-size: 1.4rem
                    width: 20%
                input
                    border: 1px solid $grayColor
                    width: 70%
                    padding: 10px
                    text-align: left
                    width: 60%
                    &:focus
                        outline: 2px solid $mainColor
                select
                    padding: 10px
                    width: 30%
        .modal_submit
            display: flex
            justify-content: center
    .modal_delete
        padding: 24px
        p
            font-size: 1.6rem
        .delete_btns
            margin-top: 40px
            display: flex
            justify-content: space-evenly
    .connectionFooter
        display: flex
        justify-content: start
    .dispAdMenu
        display: inline-block
        background: $mainColor
        color: $whiteColor
        cursor: pointer
        overflow: hidden
        height: 30px;
        padding: 7px
        margin-right: 10px
        position: relative
        width: 150px
        &::befo0e
            background: $whiteColor
            top: 0
            content: ''
            height: 100%
            left: 0
            position: absolute
            transform: translate(0%, 100%)
            transition: all .3s ease-in-out
            width: 150px
        &::after
            background: $whiteColor
            content: ''
            height: 16px
            position: absolute
            right: 8px
            transform: rotate(45deg)
            transition: all .3s ease-in-out
            top: 6px
            width: 16px
        &:hover
            color: $grayColor
            &::before
                transform: translate(0%, 0%)
            &::after
                background: $grayColor
                transform: rotate(225deg)
        .productName
            display: block
            position: relative
            width: 100px
    .selected
        background: $whiteColor
        color: $grayColor
        &::before
            transform: translate(0%, 0%)
        &::after
            background: $grayColor
            transform: rotate(225deg)
    .timeSel
        width: 100px !important
        height: 38px !important
        margin: 0 10px !important
</style>
